import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import Baggage from './Baggage';
import ItemCategory from './ItemCategory';
import BaggageConfiguration from './BaggageConfiguration';
import ItemCondition from './ItemCondition';
import BaggageDiscountCode from './BaggageDiscountCode';
import Item from './Item';
import ExcessBaggage from './ExcessBaggage';
import BaggageManifestPrint from './BaggageManifestPrint';

export default combineReducers({
  UnitHome,
  Baggage,
  ItemCategory,
  BaggageConfiguration,
  ItemCondition,
  BaggageDiscountCode,
  Item,
  ExcessBaggage,
  BaggageManifestPrint,
});
